import { Component, ContentChildren, OnInit, QueryList } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormFieldBaseComponent } from '../form-field-base.component';
import { SegmentedButtonItemComponent } from './item/segmented-button-item.component';

@Component({
    selector: 'lib-segmented-button',
    templateUrl: './segmented-button.component.html',
    styleUrl: './segmented-button.component.scss'
})
export class FormFieldSegmentedButtonComponent <T extends keyof any> extends FormFieldBaseComponent<T, FormControl<T>> implements OnInit {

    @ContentChildren(SegmentedButtonItemComponent) itemList!: QueryList<SegmentedButtonItemComponent<T>>;

    constructor() {
        super();
        this.viewControl = new FormControl<T>(null as any, {nonNullable: true});
    }

    override ngOnInit() {
        super.ngOnInit();
        this.viewControl.setValue(this.formControl.value);
    }

    ChangeEvent(value: T) {
        if (value && !this.formControl.disabled) {
            this.formControl.setValue(value);
            this.SetFormControlValue(value);
            super.OnBlur();
        }
    }

}
